/**
 * Created by Owner on 2016/10/20.
 */
export class ArrayUtil {
  //去重
  // static uniquelize(data:Array<>) {
  //   return Array.from(new Set(data))
  // }

  /**
   * data1包含data2
   * @param data1
   * @param data2
   * @returns {any}
   */
  static intersect(data1: any[], data2: any[]): any[] {
    let arr: any = [];
    data2.forEach(item=> {
      if (data1.indexOf(item) > -1) {
        arr.push(item);
      }
    });
    return arr;
  }
}



// WEBPACK FOOTER //
// ./src/util/arrayUtil.ts